import './JTBCTA.scss';
import { useNavigate } from 'react-router-dom';
import { DownloadIcon } from "./../../../../ui/Icons/DownloadIcon";

const JTBCTA = () => {
  const navigate = useNavigate();
    
      const handleClick = () => {
        navigate('/', { state: { scrollToContact: true } });
      };
    
  
  return (
    <section className='jtbd-cta section'>
      <div className='wrapper wrapper--large centered'>
        <h2 className='wrapper__title h3'>Está pronto para transformar o seu negócio <br/>com a ajuda da Plover?</h2>
        <button type="button" onClick={handleClick} className='cta-filled centered'>
          Agende uma sessão Gratuita
        </button>
        <a href="/files/JTBD-template-pt.pdf" className='link-primary' download="jtbd-template">
          <DownloadIcon />
          Faça Download do Exercício
        </a>
      </div>
    </section>
  );
};

export default JTBCTA;